/** =========================================================
 * Module: drag-download.directive.js
 * Download file on drag out
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('dragDownload', dragDownload);

  dragDownload.$inject = [];

  function dragDownload() {
    var directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link($scope, element, attributes) {
      element[0].addEventListener('dragstart', function (evt) {
        evt.dataTransfer.setData('DownloadURL', attributes.downloadurl);
      }, false);
    }
  }
})();
